import type { Event } from '@hedepy/common/schemas/modules/event/event'
import { forwardRef } from 'react'

import Icon from '@/legacy-src/components/icons/Icon'

import { ClientBookingSlotButton } from '@/src/domains/client-booking/components/ClientBookingSlotButton'

export interface ClientBookingPlannedEventTimeSlotProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'slot'> {
  event: Event
}

export const ClientBookingPlannedEventTimeSlot = forwardRef<HTMLButtonElement, ClientBookingPlannedEventTimeSlotProps>(
  ({ event, ...props }, ref) => (
    <ClientBookingSlotButton
      ref={ref}
      variant="planned"
      startDate={event.startDate}
      slotType={event.type}
      icon={<Icon className="rotate-90" icon="more" />}
      {...props}
    />
  ),
)

ClientBookingPlannedEventTimeSlot.displayName = 'ClientBookingPlannedEventTimeSlot'
